<div class="approval-form">
  @if (!cancelled && !success) {
    <div class="wrapper">
      <div class="wrapper-header">
        <h3>{{translate.instant("supplier_accept_confirmation").replace('{{value}}', bodyshopName)}}</h3>
        <span>{{"select_an_option" | translate}}</span>
      </div>
      <div class="radio-container">
        <div class="radio-wrapper" [ngClass]="{'selected': checkedStatus === 'Approved'}">
          <mat-icon [svgIcon]="'check'" aria-hidden="false" aria-label="edit icon"></mat-icon>
          <label for="">{{'approve' | translate}}</label>
          <chq-input class="company-input col-3" [inputModel]="approveRadio"
          (controlOutput)="onFormUpdate($event)"></chq-input>
        </div>
        <div class="radio-wrapper" [ngClass]="{'selected': checkedStatus === 'declined'}">
          <mat-icon [svgIcon]="'cross'" aria-hidden="false" aria-label="edit icon"></mat-icon>
          <label for="">{{'decline' | translate}}</label>
          <chq-input class="company-input col-3" [inputModel]="declineRadio"
          (controlOutput)="onFormUpdate($event)"></chq-input>
        </div>
      </div>
      <div class="button-container">
        <chq-button [buttonModel]="cancelButtonModel"></chq-button>
        <chq-button [buttonModel]="nextButtonModel"></chq-button>
      </div>
    </div>
  }
  @if (cancelled || success) {
    <div class="result">
      @if (cancelled) {
        <div class="result-content">
          <h3>{{"the_request_has_been_cancelled" | translate}}</h3>
        </div>
      }
      @if (success) {
        <div class="result-content-success">
          <h3>{{"the_supplier_was" | translate}} {{status}}</h3>
        </div>
      }
    </div>
  }
</div>
